module.exports = __webpack_public_path__ + "tangocard.png";